import { Component, OnInit } from "@angular/core";
import { GameService } from "./../../app/core/services/game.service";
import { interval, Subscription, timer } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { takeWhile } from "rxjs/operators";
import { Router } from "@angular/router";
import { Globals } from '../core/global';
import { EventsService } from '../core/services/events.service';
import { LoginService } from "../core/services/login.service";
import { BehSubjectService } from "../core/services/beh-subject.service";

@Component({
  selector: "app-question",
  templateUrl: "./question.component.html",
  styleUrls: ["./question.component.scss"]
})
export class QuestionComponent implements OnInit {
  private subscriptions: Subscription[] = [];
  precounter = true;
  runningGame: boolean;

  showPopup = false;
  timeEnd = false;
  isCorrect: boolean;
  isIncorrect: boolean;
  error: boolean;

  question: any;
  questionTimwe: any;
  counter: any;
  answers: any;
  timeCounter = 3;

  errorCode: string;
  errorMessage: string;

  clickedIndex: number;
  correctIndex: number;
  clicked = false;
  currentStageIndex: number;
  levelIndex: any;
  amount: any;
  winnerPopup = false;
  structure: any;
  helps: any;
  help1Click = false;
  help2Click = false;
  help3Click = false;
  helpSearchKey = null;
  blockHelp: boolean = false;
  moveid: number;
  ref1: number;
  helpValues = [];
  timerHelper;
  backupQuestion;
  doublePickClicked = [];
  correctDoublePick;
  incorrectDoublePick = [];
  progressLevelIndex;
  prizeLabel = "";
  answersSelected;
  reasonKey = "CORRECT_GO";
  gameLimited = false;

  gifUrl: any;
  yesGifUrl: any;
  noGifUrl: any;

  urlRedirect = false;

  loader = false;
  subsAvailable = false;
  oSAvailable = false;
  subError = false;
  nocreditError = false;
  subSuccess = false;
  private apiRequest$: string

  constructor(
    private gameservice: GameService,
    private router: Router,
    private globals: Globals,
    private events: EventsService,
    private loginService: LoginService,
    private gameService: GameService,
    public beh: BehSubjectService,
  ) {
    this.subscriptions.push(this.beh.apiRequest$.subscribe((val) => {this.apiRequest$ = val;}));
  }

  ngOnInit() {
    this.getPlayer();
    this.gameservice.mainLoader.next(true);
    this.getQuestion();

    let answerRandom = Math.floor(Math.random() * 3) + 1;

    this.yesGifUrl = `${this.globals.cacheFlyUrl}correct/0${answerRandom}.gif`
    this.noGifUrl = `${this.globals.cacheFlyUrl}incorrect/0${answerRandom}.gif`
  }

  getPlayer() {
    
    this.gameService.getPlayerData().subscribe((response: any) => {
      if (response.responseData.products) {
        let playerSubs = response.responseData.products.find(x => x.searchKey == "SUBSCRIPTION");
        
        if (playerSubs.status == 'ACTIVE' ||  playerSubs.status =='EMPTY' && response.isSubscribed) {
          this.oSAvailable = true;
        } else {
          this.subsAvailable = true;
        }
      }
    });
  }

  getQuestion() {
    this.gameservice.getQuestion().subscribe(data => {

      this.gameservice.mainLoader.next(false);

      if (data["responseCode"] == 400) {
        this.errorCode = data["responseData"].errorCode;
        this.errorMessage = data["responseData"].errorMessage;

        // if (this.errorCode != 'WITHOUT_GAME' && this.errorCode != 'ALREADY_IN_PROGRESS' && this.errorCode != 'CHANNEL_LIMIT_REACHED_FREE') {
        //   this.router.navigate(['/start-game']);
        // }
      } else {
        this.currentStageIndex = data["responseData"].stageIndex;

        this.levelIndex = data["responseData"].levelIndex;
        this.progressLevelIndex = data["responseData"].levelIndex;

        let random = Math.floor(Math.random() * 2) + 1;
        if (this.progressLevelIndex == localStorage.getItem("lastQuestion")) {
          this.gifUrl = `${this.globals.cacheFlyUrl}last-level/0${random}.gif`
        } else {
          this.gifUrl = `${this.globals.cacheFlyUrl}stage${this.currentStageIndex}/0${random}.gif`
        }
        this.moveid = data["responseData"].moveId;
        this.ref1 = data["responseData"].ref1;

        // this.prizeLabel = data['responseData'].prizes[0].amount;

        this.question = data["responseData"].label;
        this.answers = data["responseData"].answers;
        this.counter = data["responseData"].timeToAnswer + 3;
        this.helps = data["responseData"].helps;

        this.backupQuestion = data["responseData"].backupQuestion;

        this.timerHelper = this.counter * 1000 + 1;

        timer(this.timerHelper).subscribe(data => {
          this.timeEnd = false;
          this.clicked = true;
          this.counter = this.counter - 1;
          if (!this.isCorrect) {
            this.gameservice
              .getCorrectAnswer(-1, this.moveid, 0, this.helpSearchKey)
              .subscribe(data => {
                console.log(data["responseData"]);
              });
            this.isCorrect = false;
            this.winnerPopup = true;
          }
          if (this.counter <= 0) {
            this.timeEnd = true;
            this.showPopup = true;
          }
        });

        timer(3000).subscribe(() => { this.precounter = false; });

        interval(1000).pipe(takeUntil(timer(3001))).subscribe(() => {
          this.timeCounter = this.timeCounter - 1;
        });

        interval(1000).pipe(takeWhile(() => !this.clicked)).subscribe(() => {
          this.counter = this.counter - 1;
        });
      }
    });
  }

  validateClick(answerIndex) {
    if (!this.clicked) {
      if (this.help1Click) {
        if (this.doublePickClicked.length < 2) {
          this.doublePickClicked.push(answerIndex);
        }
        if (this.doublePickClicked.length == 2) {
          this.clicked = true;
          this.gameservice
            .getCorrectAnswer(
              this.doublePickClicked[0],
              this.moveid,
              this.counter,
              this.helpSearchKey,
              this.doublePickClicked[1]
            )
            .subscribe(data => {
              if (data["responseData"].isCorrect) {
                this.correctDoublePick = data["responseData"].correctAnswer.index;
                this.isCorrect = true;
                this.structure = JSON.parse(localStorage.getItem("structure")).reverse();
              } else {
                this.incorrectDoublePick = this.doublePickClicked;
                if (this.incorrectDoublePick.length == 2) {
                  this.events.eventStart({ eventType: 'GAME_PLAYED_SUCCESS', triggerType: 'success',responseData: JSON.stringify(data) });
                  this.gameservice.gameFinish().subscribe();
                  this.isCorrect = false;
                  this.correctDoublePick = data["responseData"].correctAnswer.index;
                }
              }
              timer(3000).subscribe(data => {
                this.showPopup = true;
              });
              this.answersSelected = null;
            });
        }
      } else {
        this.getCorrectAnswer(answerIndex);
      }
    }
  }

  getCorrectAnswer(answerIndex) {
    this.runningGame = false;
    this.answersSelected = answerIndex;
    if (!this.clicked) {
      this.gameservice
        .getCorrectAnswer(
          answerIndex,
          this.moveid,
          this.counter,
          this.helpSearchKey
        )
        .subscribe(data => {
          localStorage.setItem("reasonKey", btoa(data["responseData"].reasonKey));

          this.isCorrect = data["responseData"].isCorrect;
          this.clickedIndex = answerIndex;
          this.correctIndex = answerIndex;
          if (!this.isCorrect) {
            this.events.eventStart({ eventType: 'GAME_PLAYED_SUCCESS', triggerType: 'success',responseData: JSON.stringify(data) });
            const correctAnswer = data["responseData"].correctAnswer.index;
            this.correctIndex = correctAnswer;
          } else {
            this.structure = JSON.parse(localStorage.getItem("structure")).reverse();
            if (
              this.progressLevelIndex == localStorage.getItem("lastQuestion")
            ) {
              this.urlRedirect = true;
            }
          }
          timer(3000).subscribe(data => {
            this.showPopup = true;
          });
          this.answersSelected = null;
        });

      this.clicked = true;
    }
  }
  getLetter(index) {
    return String.fromCharCode(65 + index);
  }
  getHelp(searchKey) {
    this.helpSearchKey = searchKey;

    console.log(searchKey);

    this.gameservice.getHelpOK(searchKey).subscribe(data => {
      if (data["responseCode"] < 400) {

        this.blockHelp = true;

        if (searchKey === "DOUBLE_PICK") {
          this.help1Click = true;
        }
        if (searchKey === "FIFTY_FIFTY") {
          this.help2Click = true;

          const bitWise = this.ref1 - this.moveid - this.currentStageIndex - this.levelIndex;

          for (let i = 0, calcHelp = 16; i < this.answers.length; i++) {
            this.helpValues[i] = calcHelp & bitWise;
            calcHelp = calcHelp * 2;
          }
        }
        if (searchKey === "SWITCH_QUESTION") {
          this.help3Click = true;
          this.timerHelper = 10001;
          this.counter = 10;
          this.answers = this.backupQuestion.answers;
          this.question = this.backupQuestion.label;
        }
      }
    });
  }

  productBuySubscription() {
    this.events.eventStart({ eventType: 'SUBSCRIPTION', triggerType: 'subscription' });

    this.loader = true;
    if (this.subsAvailable) {
      this.loginService.productBuy('SUBSCRIPTION').subscribe(data => {
        if (data['responseCode'] == 200) {
          if (data['responseData'].status == 'BILLINGERROR') {
            this.events.eventStart({ eventType: 'SUBSCRIPTION_ERROR', triggerType: 'error', responseData: JSON.stringify(data), requestData: this.apiRequest$ });
            this.subError = true;
            this.loader = false;
          } else if (data['responseData'].status == 'NO_CREDIT' || data['responseData'].status == 'NOCREDIT'){
            this.events.eventStart({ eventType: 'SUBSCRIPTION_ERROR', triggerType: 'error', responseData: JSON.stringify(data), requestData: this.apiRequest$ });
            this.nocreditError = true;
            this.loader = false;
          } else {
            this.events.eventStart({ eventType: 'SUBSCRIPTION_SUCCESS', triggerType: 'success', responseData: JSON.stringify(data), requestData: this.apiRequest$ });
            this.subSuccess = true;
            this.loader = false;
          }
        } else {
          this.events.eventStart({ eventType: 'SUBSCRIPTION_ERROR', triggerType: 'error', responseData: JSON.stringify(data), requestData: this.apiRequest$ });
          this.subError = true;
          this.loader = false;
        }
      });
    } else {
      this.subError = true;
      this.loader = false;
    }
  }

  productBuyOs() {
    this.events.eventStart({ eventType: 'SUBSCRIPTION', triggerType: 'oneshot' });
    this.loader = true;
    if (this.oSAvailable) {
      this.loginService.productBuy('ONE_SHOT').subscribe(data => {
        if (data['responseCode'] == 200) {
          if (data['responseData'].status == 'BILLINGERROR') {
            this.events.eventStart({ eventType: 'SUBSCRIPTION_ERROR', triggerType: 'error', responseData: JSON.stringify(data), requestData: this.apiRequest$ });
            this.subError = true;
            this.loader = false;
          } else if (data['responseData'].status == 'NO_CREDIT' || data['responseData'].status == 'NOCREDIT') {
            this.events.eventStart({ eventType: 'SUBSCRIPTION_ERROR', triggerType: 'error', responseData: JSON.stringify(data), requestData: this.apiRequest$ });
            this.nocreditError = true;
            this.loader = false;
          } else {
            this.events.eventStart({ eventType: 'SUBSCRIPTION_SUCCESS', triggerType: 'success', responseData: JSON.stringify(data), requestData: this.apiRequest$ });
            this.subSuccess = true;
            this.loader = false;
          }
        } else {
          this.events.eventStart({ eventType: 'SUBSCRIPTION_ERROR', triggerType: 'error', responseData: JSON.stringify(data), requestData: this.apiRequest$ });
          this.subError = true;
          this.loader = false;
        }
      });
    } else {
      this.subError = true;
      this.loader = false;
    }
  }
}
